import { useLayoutEffect } from 'react';

/**
 * Keeps the active mode's input delegate registered in a shared ref for the canvas input manager.
 */
const useDrawingCanvasModeInputLayerDelegate = ({ inputLayerDelegateRef, inputLayerDelegate }) => {
    useLayoutEffect(() => {
        if (!inputLayerDelegateRef) return undefined;

        inputLayerDelegateRef.current = inputLayerDelegate;

        return () => {
            if (inputLayerDelegateRef.current === inputLayerDelegate) {
                inputLayerDelegateRef.current = null;
            }
        };
    }, [inputLayerDelegate, inputLayerDelegateRef]);
};

export default useDrawingCanvasModeInputLayerDelegate;
